<mat-dialog-content class="dialog-content">
  <button type="button" mat-icon-button class="dialog-close-button" (click)="close()" [attr.aria-label]="'close_tr' | translate" tabindex="-1">
    <mat-icon>close</mat-icon>
  </button>
  <div class="sticky-header">
    <h3>{{ 'search_reports_tr' | translate }}</h3>
    <form [formGroup]="product">
      <mat-form-field>
        <mat-label>{{ 'Article_Number_tr' | translate }}</mat-label>
        <app-article-numbers-field
          [formControl]="articleNumbers"
          [placeholder]="'add_article_number_tr' | translate"
        ></app-article-numbers-field>
        <mat-hint>{{ 'Type_a_number_and_press_comma_tr' | translate }}</mat-hint>
      </mat-form-field>

      <mat-form-field class="validity-field">
        <mat-label>{{ 'report_validity_date_tr' | translate }}</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="validityDate" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint>{{ 'select_date_to_find_valid_reports_tr' | translate }}</mat-hint>
      </mat-form-field>
    </form>

    @if (matchingReports && matchingReports.missingArticleNumbers.length > 0 && !hideUnmatchedWarning) {
      <div class="unmatched-warning">
        <div class="warning-header">
          <mat-icon>warning</mat-icon>
          <strong>{{ 'no_reports_found_for_articles_tr' | translate }}</strong>
          <button type="button" mat-icon-button class="close-button" (click)="hideWarning()" [attr.aria-label]="'close_tr' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="unmatched-list">
          @for (articleNum of matchingReports.missingArticleNumbers; track articleNum) {
            <span class="unmatched-chip">{{ articleNum }}</span>
          }
        </div>
      </div>
    }
  </div>
  <div class="columns-grid">
    <div class="search-column">
      <h3>
        {{ 'search_results_tr' | translate }}
        @if (matchingReports && matchingReports.totalElements > 0) {
          ({{ matchingReports.content.length }} / {{ matchingReports.totalElements }})
        }
      </h3>
      <div class="reports-list" (scroll)="onScroll($event)">
        @if (matchingReports && matchingReports.totalElements > 0) {
          @for (report of matchingReports.content; track report.id) {
            <app-report-overview-card
              [report]="report"
              action="add"
              variant="search"
              [disabled]="!canAddReport(report)"
              [cssClass]="isReportSelected(report.id) ? 'already-selected' : ''"
              [articleNumbers]="report.articleNumbers"
              [showPreview]="true"
              (actionClick)="toggleReportSelection(report.id)"
              (previewClick)="previewReport(report)"
            />
          }
        } @else {
          <div class="no-reports">{{ 'enter_search_criteria_tr' | translate }}</div>
        }
      </div>
    </div>

    <div class="selected-column">
      <h3>{{ 'selected_reports_tr' | translate }} ({{ (product.value.selectedReports || []).length }})</h3>
      <div class="reports-list">
        @if ((product.value.selectedReports || []).length > 0) {
          @for (reportId of product.value.selectedReports; track reportId) {
            <app-report-overview-card
              [report]="reportCache.get(reportId)!"
              [reportId]="reportId"
              action="remove"
              variant="selected"
              [showPreview]="true"
              (actionClick)="removeReport(reportId)"
              (previewClick)="previewReport(reportCache.get(reportId)!)"
            />
          }
        } @else {
          <div class="no-reports">{{ 'no_report_selected_tr' | translate }}</div>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>
